export default "__VITE_ASSET__B07uuOF4__"